let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h9hWQ")).then(() => parcelRequire('c5zgi'));